import React, { useEffect, useState,useContext } from "react";

import { useSelector, useDispatch } from "react-redux";

//import context
import { MyContext } from "../../../../tenantsDashContext";

// Define the styles object
const styles = {
  tenantList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  individualTenant: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.28)",
    padding: "7px 15px",
    borderRadius: "10px",
    alignItems: "center",
    cursor: "pointer",
  },
  left: {
    display: "flex",
    gap: "15px",
  },
  shape: {
    width: "35px",
    height: "35px",
    backgroundColor: "#0B2C3C",
    borderRadius: "50%",
  },
  nameAndDate: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontSize: "18px",
    fontWeight: "300",
  },
  dateJoined: {
    fontSize: "14px",
    fontFamily: '"Roboto", sans-serif',
    fontWeight: "200",
    color: "#A8B4CC",
    marginTop: "2px",
  },
  end: {
    fontSize: "16px",
    fontWeight: "400",
  },
  extraInfo: {
    width: "100%",
    margin: "20px 0",
    padding: "1rem",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  extraInfoTitle: {
    fontSize: "18px",
    fontFamily: '"Karla", sans-serif',
    fontWeight: "500",
    marginBottom: "10px",
  },
  detailsAndTitle: {
    display: "flex",
    width: "90%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
  },
  tile: {
    fontSize: "16px",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: "200",
  },
  details: {
    fontWeight: "400",
    fontSize: "16px",
    fontFamily: '"Poppins", sans-serif',
  },
  button: {
    backgroundColor: "#0B2C3C",
    color: "white",
    padding: "7px 10px",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
    fontSize: "14px",
  },
};

const TenantsList = ({ handleShowModal, setTenantData }) => {
  //context
  const { rolesAssigned } = useContext(MyContext);

  //data fetched from store
  const {
    user,
    profile,
    tenants: tenantsList,
  } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [tenants, setTenants] = useState([]);
  const [visibleTenantsCount, setVisibleTenantsCount] = useState(3);

  const handleShowMore = () => {
    setVisibleTenantsCount((prevCount) => prevCount + 3); // Show 3 more tenants
  };

  const handleHideAll = () => {
    setVisibleTenantsCount(3); // Reset to initial count
  };

  useEffect(() => {
    setTenants(extractTenantInfo(tenantsList));
  }, [tenantsList]);

  const [expandedTenantIndex, setExpandedTenantIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedTenantIndex(expandedTenantIndex === index ? null : index);
  };

  return (
    <div style={styles.tenantList}>
      {tenants.slice(0, visibleTenantsCount).map((tenant, index) => (
        <div key={index} style={{ width: "100%" }}>
          <div
            style={styles.individualTenant}
            onClick={() => toggleExpand(index)}
          >
            <div style={styles.left}>
              <div style={styles.shape}></div>
              <div style={styles.nameAndDate}>
                <div style={styles.name}>{tenant.name}</div>
                <div style={styles.dateJoined}>{tenant.dateJoined}</div>
              </div>
            </div>
            <div style={styles.end}>{tenant.apartmentNumber}</div>
          </div>
          {/* Expanded section */}
          {expandedTenantIndex === index && (
            <div style={styles.extraInfo}>
              <div style={styles.extraInfoTitle}>Tenant Details</div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>Tenant ID:</div>
                <div style={styles.details}>{tenant.id}</div>
              </div>

              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>Phone Number:</div>
                <div style={styles.details}>{tenant.phoneNumber}</div>
              </div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>National id Number:</div>
                <div style={styles.details}>{tenant.nationalID}</div>
              </div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>House Type:</div>
                <div style={styles.details}>{tenant.houseType}</div>
              </div>
              <div style={styles.detailsAndTitle}>
                <div style={styles.tile}>Email:</div>
                <div style={{ ...styles.details, fontSize: "14px" }}>
                  {tenant.email}
                </div>
              </div>

              {rolesAssigned?.manageTenants && <>
                <div
                style={styles.button}
                onClick={() => {
                  handleShowModal("modify tenant");
                  setTenantData({
                    id: tenant.id,
                    name: tenant.name,
                    dateJoined: tenant.dateJoined,
                    apartmentNumber: tenant.apartmentNumber,
                    email: tenant.email,
                    houseType: tenant.houseType,
                    firstName: tenant.name.split(" ")[0],
                    lastName: tenant.name.split(" ")[1],
                    phoneNumber: "123-456-7890",
                    nationalID: tenant.nationalID,
                  });
                }}
              >
                Edit Tenant
              </div>
              
              </>}
             
            </div>
          )}
         
        </div>
      ))}

       {/* Show More and Hide All Buttons */}
       {visibleTenantsCount < tenants.length && (
            <div style={{ marginTop: "10px" }}>
              <button style={styles.button} onClick={handleShowMore}>
                Show More
              </button>
            </div>
          )}
          {visibleTenantsCount > 3 && (
            <div style={{ marginTop: "10px" }}>
              <button style={styles.button} onClick={handleHideAll}>
                Hide All
              </button>
            </div>
          )}
    </div>
  );
};

function extractTenantInfo(tenants) {
  console.log("my tenants", tenants);
  return tenants.map((tenant, index) => {
    return {
      // id: `T${(tenant.tenant_id + 1).toString().padStart(3, '0')}`, // Assigns an ID like T001
      id: tenant.tenant_id,
      name: tenant.tenant_name || "N/A", // Using caretaker name
      dateJoined: new Date(tenant.created_at).toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      }), // Formatting the date
      apartmentNumber: tenant.house.house_number || "N/A", // Apartment number
      email: tenant.tenant_email || "N/A", // Caretaker email
      phoneNumber: tenant.tenant_phone_number || "N/A", // Caretaker phone number
      houseType: tenant.house.house_type || "N/A", // House type
      houseId: tenant.house.house_id || "N/A", // House ID
      nationalID: tenant.tenant_id_number || "N/A", // National ID
      profilePicture: "", // No profile picture provided
      emergency_contact_phone: tenant.emergency_contact_phone || "N/A",
    };
  });
}

export default TenantsList;
